import React, { useState } from 'react';
import AuthHero from '../components/AuthHero';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = 'https://api.starhubcreative.id';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal mengirim email');
    } finally { setLoading(false); }
  };

  return (
    <div className="sh-auth" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'transparent' }}>
      <AuthHero />
      <div className="sh-auth-card" style={{ width: '100%', maxWidth: 400, background: '#FFFFFF', boxShadow: '0 4px 24px rgba(17,24,39,0.06)', border: '1px solid #E5E7EB', borderRadius: 16, padding: 32 }}>
        <img src="/logo-full-v2.png" alt="Starhub Creative" style={{ height: 56, marginBottom: 24 }} />

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
            <h2 style={{ color: '#111827', marginBottom: 8 }}>Email Terkirim!</h2>
            <p style={{ color: '#6B7280', fontSize: 14, marginBottom: 24 }}>Cek inbox kamu untuk link reset password. Link valid selama 1 jam.</p>
            <Link to="/login" style={{ color: '#FF5722', fontSize: 14 }}>← Kembali ke Login</Link>
          </div>
        ) : (
          <>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: '#111827', marginBottom: 4 }}>Lupa Password</h1>
            <p style={{ fontSize: 14, color: '#6B7280', marginBottom: 28 }}>Masukkan email akun kamu</p>
            {error && <div style={{ background: 'rgba(239,68,68,0.16)', border: '1px solid #ef4444', color: '#ef4444', padding: '10px 14px', borderRadius: 8, fontSize: 14, marginBottom: 16 }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 20 }}>
                <label style={{ display: 'block', fontSize: 13, color: '#6B7280', marginBottom: 6 }}>Email</label>
                <input type="email" placeholder="email@kamu.com" value={email} onChange={e => setEmail(e.target.value)} required style={{ fontSize: 16 }} />
              </div>
              <button type="submit" className="btn btn-gold" style={{ width: '100%', padding: 14, fontSize: 16 }} disabled={loading}>
                {loading ? 'Mengirim...' : 'Kirim Link Reset'}
              </button>
            </form>
            <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14 }}>
              <Link to="/login" style={{ color: '#6B7280', textDecoration: 'none' }}>← Kembali ke Login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
